import { useCallback, useEffect, useState } from "react";
import { ExportJob } from "src/graphql/generated/graphql";
import { campaignResultsExportJobsQuery } from "src/graphql/operations/campaignResultsExportJobs/query";
import { graphqlFetch } from "src/graphql/utils/graphqlFetch";

import { handleError } from "../utils/error";
import { useAuthContext } from "./auth";

export const useCampaignResultsExportJobs = (campaignId: string) => {
    const { client: selectedClient } = useAuthContext();
    const [exportJobs, setExportJobs] = useState<ExportJob[]>([]);
    const [isLoadingExportJobs, setIsLoadingExportJobs] = useState(false);

    const fetchExportJobs = useCallback(
        async (campaignId: string) => {
            setIsLoadingExportJobs(true);

            try {
                const response = await graphqlFetch(campaignResultsExportJobsQuery, {
                    campaignId,
                    clientId: selectedClient?.id,
                });

                setExportJobs(response.campaign?.resultsExportJobs);
            } catch (err) {
                handleError(err, {
                    message: { key: "campaign_load_failed", namespace: "common" },
                    context: { campaignId, clientId: selectedClient?.id },
                });
            } finally {
                setIsLoadingExportJobs(false);
            }
        },
        [selectedClient?.id]
    );

    useEffect(() => {
        if (!campaignId) {
            return;
        }

        fetchExportJobs(campaignId);
    }, [campaignId, fetchExportJobs]);

    return {
        exportJobs,
        isLoadingExportJobs,
        reloadExportJobs() {
            fetchExportJobs(campaignId);
        },
    };
};
